module.exports = __webpack_public_path__ + "img/link.4e5758e.png";